





















import { defineComponent, getCurrentInstance, onMounted, onUnmounted, ref } from "@vue/composition-api";
import { ValidationObserver } from "vee-validate";
import { FormFields, FormValues } from "@/types";
import FieldPrinter from "@/components/FieldPrinter";

export default defineComponent({
  name: "BaseForm",
  components: { FieldPrinter, ValidationObserver },
  model: { prop: "values" },
  props: {
    fields: { type: Array as () => FormFields, required: true },
    values: { type: Object as () => FormValues, required: true },
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance();
    const validator = ref<InstanceType<typeof ValidationObserver>>();
    const onSubmit = async () => {
      validator.value?.validate();
      await vm?.$nextTick();
      if (!validator.value?.flags.valid) {
        return;
      }
      emit("submit", props.values);
      emit("input", props.values);
    };
    let unWatch = () => {};
    onMounted(() => {
      if (!validator.value) return;
      emit("setManualValidate", () => validator.value?.validate());
      unWatch = validator.value.$watch("flags.valid", newData => emit("validation", newData), {
        immediate: true,
      });
    });
    onUnmounted(() => unWatch());

    return {
      onSubmit,
      validator,
    };
  },
});
